import { createRouter, createWebHashHistory } from 'vue-router'
// import HomeView from '../views/HomeView.vue'

const routes = [
  {
    path: '/',
    name: 'home',
    component: () => import('../views/HomeView.vue')
    // component: HomeView
  },
  {
    path: '/mls',
    name: 'mls',
    component: () => import('../views/MLSView.vue')
  },
  {
    path: '/featured',
    name: 'featured',
    component: () => import('../views/FeaturedView.vue')
  },
  {
    path: '/sold',
    name: 'sold',
    component: () => import('../views/SoldView.vue')
  },
  {
    path: '/detail/:name/:sysid',
    name: 'detail',
    component: () => import('../views/DetailView.vue')
  },
  {
    path: '/about',
    name: 'about',
    component: () => import('../views/AboutView.vue')
  }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

export default router
